import { render, staticRenderFns } from "./philipponnat.vue?vue&type=template&id=8b26a2f2&scoped=true"
import script from "./philipponnat.vue?vue&type=script&lang=js"
export * from "./philipponnat.vue?vue&type=script&lang=js"
import style0 from "./philipponnat.vue?vue&type=style&index=0&id=8b26a2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b26a2f2",
  null
  
)

export default component.exports